<template>
  <div class="content">
    <h2 class="title">O limite de cartazes foi atingido!</h2>
    <p>
      Para continuar a utilização do Tagsell e aproveitar todas as suas
      <br>
      funcionalidades, adquira já a sua licença na nossa loja virtual.
    </p>

    <br>

    <p v-if="!isStoreCustomer">
      Clique no botão para ativar seu cadastro.
    </p>

    <br>

    <div class="col-md-12 d-flex justify-center activate-button-div">
      <button
        v-if="!showStoreLink"
        type="button"
        @click="linkStore()"
        class="text-uppercase bold btn btn-tagsell col-lg-4 col-md-12 col-sm-12 mb-50">
        ativar
        <i v-if="requesting" class="fa fa-spin fa-circle-o-notch"></i>
      </button>

      <a
        v-if="showStoreLink"
        target="_blank"
        href="https://loja.tagsell.com.br/minha-conta/"
        class="text-uppercase bold btn btn-tagsell col-lg-4 col-md-12 col-sm-12">
        Ir para Loja
      </a>
    </div>

    <template v-if="successLinked">
      <br>

      <p class="success-message text-success">
        <i class="fa fa-check-circle-o text-success fa-2x md-mr-5"></i>
        Cadastrado ativado com sucesso!
      </p>

      <p class="store-tutorial">
        1. Será enviado um link de confirmação para o mesmo
        <br>
        e-mail que você utiliza para entrar no TAGSELL.
      </p>

      <br>

      <p class="store-tutorial">
        2. Após a confirmação, seu cadastro na loja estará pronto e vinculado
        <br>
        à sua conta TAGSELL. Assim, as licenças e campanhas compradas serão liberadas
        <br>
        automaticamente após a confirmação de pagamento.
      </p>

      <br>

      <p class="store-tutorial">
        3. Você também receberá um e-mail de boas-vindas contendo
        <br>
        sua senha para entrar na loja e um link onde você poderá visualizar todos os
        <br>
        dados de sua conta.
      </p>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'poster-limit-content',

    data() {
      return {
        requesting: false,
        successLinked: false,
        showStoreLink: window.is_store_customer,
      };
    },

    computed: {
      isStoreCustomer() {
        return window.is_store_customer || this.successLinked;
      }
    },

    methods: {
      linkStore() {
        this.requesting = true;
        axios.post('/ajax/current-user/link-store').then((response) => {
          this.successLinked = true;
          this.showStoreLink = true;

          this.$root.throwFlashMessage(response.data.type, response.data.message);
        }).catch((error) => {
          if (error.response.status === 300)
            this.showStoreLink = true;

          this.$root.throwFlashMessage(error.response.data.type, error.response.data.message);
        }).finally(() => this.requesting = false);
      },
    },
  };
</script>

<style scoped>
  .content {
    font-family: Montserrat;
  }

  .title {
    text-align: center;
    font-weight: bold;
    color: #ED1763;
  }

  .btn-tagsell {
    background-color: #ED1763;
    color: #fff;
  }

  @media screen and (max-width: 768px) {
    .btn-tagsell {
      display: block;
      width: 100%;
    }
  }

  p {
    color: #7b7b7b;
    font-size: 1.2em;
    margin-top: 15px;
    width: 100%;
    text-align: center;
    font-weight: bold;
  }

  .d-flex {
    display: flex;
  }

  .justify-center {
    justify-content: center;
  }

  .activate-button-div {
    margin: 20px 0;
  }

  .success-message {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2em;
    margin-top: 15px;
    color: #7accbe !important;
  }

  .store-tutorial {
    font-size: 1em;
  }

  .mb-50 {
    margin-bottom: 50px !important;
  }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/PosterLimitContent.vue